
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $ea2e8e3460b67692$exports = {};

$parcel$export($ea2e8e3460b67692$exports, "spectrum--darkest", () => $ea2e8e3460b67692$export$4ecdba604f5f1f44, (v) => $ea2e8e3460b67692$export$4ecdba604f5f1f44 = v);
var $ea2e8e3460b67692$export$4ecdba604f5f1f44;
$ea2e8e3460b67692$export$4ecdba604f5f1f44 = `R-l9gW_spectrum--darkest`;


export {$ea2e8e3460b67692$exports as default};
//# sourceMappingURL=vars_spectrum-darkest_css.module.js.map
